import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]

import { computed } from 'vue'

import type {
  PrioritySlaDto,
  PrioritySlaThresholds
} from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { formatSlaChipText, resolveLiveSla } from '../slaFormat'
import PrioritySlaStateBadge from './PrioritySlaStateBadge.vue'

/**
 * Chip do estado (M3): ícone + rótulo; Urgente/Atenção com "· 13 min";
 * Estourado com "+2h42"; Concluído com a hora (Antecipe pago: "Concluído · Antecipe
 * pago", sem hora — A1 25/09). O ESTADO anda no tique
 * (`nowMs` + limiares); a etapa só muda no refresh de 60 s (A26).
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PrioritySlaChip',
  props: {
    sla: {},
    nowMs: { default: null },
    thresholds: { default: null },
    testId: { default: 'priority-sla-chip' }
  },
  setup(__props: any) {

const props = __props;



const live = computed(() =>
  props.sla ? resolveLiveSla(props.sla, props.nowMs, props.thresholds) : null
)

const text = computed(() =>
  live.value && props.sla
    ? formatSlaChipText(live.value, props.sla.completedAt, props.nowMs, props.sla.completedBy)
    : ''
)

return (_ctx: any,_cache: any) => {
  return (live.value)
    ? (_openBlock(), _createBlock(PrioritySlaStateBadge, {
        key: 0,
        state: live.value.state,
        "test-id": _ctx.testId
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(text.value), 1)
        ]),
        _: 1
      }, 8, ["state", "test-id"]))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "text-xs text-neutral50",
        "data-testid": `${_ctx.testId}-missing`
      }, "—", 8, _hoisted_1))
}
}

})